import TypographyParagraph from '../typography/TypographyParagraph'
import clsx from 'clsx'
import { Switch, Field, Label } from '@headlessui/react'

const Toggle = ({
	name = 'Toggle',
	isEnabled = false,
	onEnabledChange = undefined,
}: {
	name: string
	isEnabled: boolean
	onEnabledChange?: (enabled: boolean) => void
}) => {
	return (
		<Field as="div" className="flex items-center">
			<Switch
				checked={isEnabled}
				onChange={newEnabled => {
					if (onEnabledChange) onEnabledChange(newEnabled)
				}}
				className={clsx(
					isEnabled
						? 'bg-textPrimaryLight dark:bg-textPrimaryDark'
						: 'bg-textInactiveLight dark:bg-uiSecondaryDark',
					'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none',
				)}
			>
				<span
					aria-hidden="true"
					className={clsx(
						isEnabled
							? 'translate-x-5 bg-white dark:bg-uiSecondaryDark'
							: 'translate-x-0 bg-white dark:bg-textInactiveDark',
						'pointer-events-none inline-block h-5 w-5 transform rounded-full shadow ring-0 transition duration-200 ease-in-out',
					)}
				/>
			</Switch>
			<Label as="div" className="ml-2">
				<TypographyParagraph size="medium">{name}</TypographyParagraph>
			</Label>
		</Field>
	)
}

export default Toggle
